exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".snapshot-list-list-cAfpw{width:100%}.snapshot-list-item-2RrGe{padding:16px 0 16px 32px;box-sizing:border-box}.snapshot-list-time-3Bg89{font-weight:600;font-size:14px;color:rgba(0,0,0,.64);line-height:20px;margin-bottom:8px;text-align:left}.snapshot-list-actions-38gCH{display:flex;align-items:center}.snapshot-list-action-2PWbh+.snapshot-list-action-2PWbh{margin-left:8px}", ""]);

// Exports
exports.locals = {
	"list": "snapshot-list-list-cAfpw",
	"item": "snapshot-list-item-2RrGe",
	"time": "snapshot-list-time-3Bg89",
	"actions": "snapshot-list-actions-38gCH",
	"action": "snapshot-list-action-2PWbh"
};